// test470
(470 && 0);
